import {
  addDoc,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  setDoc,
} from "firebase/firestore";
import { useState } from "react";
import { showMessage } from "../../components/message/GenericMessage";
import { db } from "../../firebase/firebase";
import { useUpload } from "../useUpload";

// delete data
export function DeleteData(ref) {
  deleteDoc(ref)
    .then(() => {
      showMessage("Deleted successfully", "success");
    })
    .catch(() => {
      showMessage("Delete failed", "error");
    });
}

export function useFirebase() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { deleteImages } = useUpload();

  function deleteData(ref, imageUrls) {
    // if images there
    if (imageUrls?.length > 0) {
      deleteImages(imageUrls);
    }

    deleteDoc(ref)
      .then(() => {
        showMessage("Deleted successfully", "success");
      })
      .catch(() => {
        showMessage("Delete failed", "error");
      });
  }

  // post data
  async function addData(ref, values, callback) {
    setLoading(true);
    // Add a new document with a generated id.
    await addDoc(ref, values)
      .then(() => {
        showMessage("Added Successfully!", "success");
        if (callback) callback();
      })
      .catch((err) => {
        showMessage(err.message, "error");
      });
    setLoading(false);
  }

  // set data to id
  async function setDocData(ref, id, data, callback) {
    setLoading(true);
    // Add a new document with a generated id.
    await setDoc(doc(ref, id), data, { merge: true })
      .then(() => {
        showMessage("Added Successfully!", "success");
        if (callback) callback();
      })
      .catch((err) => {
        showMessage(err.message, "error");
      });
    setLoading(false);
  }

  // update data
  // can also be used to set data if doc ref passed e.g doc(db, "orders", id)
  async function updateData(ref, data, displayMessage = true) {
    // remove existing ref & id
    const updatedData = { ...data };
    delete updatedData.docRef;
    delete updatedData.id;

    setLoading(true);
    await setDoc(ref, updatedData, { merge: true })
      .then(() => {
        if (displayMessage) showMessage("Updated successfully", "success");
      })
      .catch((err) => {
        showMessage("Update failed", "error");
        console.log(err);
      });
    setLoading(false);
  }

  // snapshot data
  function listenData(query, callback) {
    setLoading(true);
    onSnapshot(query, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        docRef: doc.ref,
      }));
      if (callback) callback();
      setData(data);
      setLoading(false);
    });
  }

  // get data
  async function getData(query) {
    setLoading(true);
    await getDocs(query)
      .then((snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          docRef: doc.ref,
        }));
        setData(data);
      })
      .catch((err) => {
        showMessage(err.message, "error");
      });
    setLoading(false);
  }

  // get single doc
  async function getDocData(ref) {
    setLoading(true);
    await getDoc(doc(db, ref))
      .then((snapshot) => {
        const data = {
          ...snapshot.data(),
          id: snapshot.id,
          docRef: snapshot.ref,
        };
        setData(data);
      })
      .catch((err) => {
        showMessage(err.message, "error");
      });
    setLoading(false);
  }

  return {
    data,
    loading,
    addData,
    setDocData,
    updateData,
    getData,
    getDocData,
    listenData,
    deleteData,
  };
}
